/* eslint-disable max-len */
import { RouteRecordRaw } from 'vue-router';

const InformationMainPage = () =>
  import(/* webpackChunkName: "InformationMainPage" */ 'PortalDir/modules/Information/pages/InformationMainPage.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'information',
    component: InformationMainPage,
  },
];

export default routes;
